import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import useAuth from "./useAuth";

const useLogout = () => {
    const { setAuth } = useAuth();
    const axiosPrivate = useAxiosPrivate();

    const logout = async () => {
        try {
            await axiosPrivate.post('auth/logout/');
            setAuth({})
        } catch (err) {
            console.log(err)
        }
    }

    return logout;
}

export default useLogout